// @ts-check
import AppStore from "Stores/AppStore";

export const MkMessagingItems = () => {
    let { pageTitle, params } = AppStore.lastPageInfo;
    let returnParams = '';

    // @ts-ignore
    if (pageTitle === 'mkMessageList' && params != null && params.page != null)
        // @ts-ignore
        returnParams = `?page=${params.page}`;

    return [
        {
            id: 'back',
            linkTo: `${window.SmrLocation}/mkMessaging/mkMessageList${returnParams}`,
            title: 'Назад',
            icon: 'us-back-menu',
            isDisabled: false,
            isError: false,
            isSelected: true,
            onClick: () => { },
            isAvailable: true
        }
    ]
}